import { Component, Prop, Vue } from 'vue-property-decorator';
import HearingService from '../../../services/HearingService';
import NoteTaskSave from '../../../models/NoteTaskSave';
import NoteTaskService from '../../../services/NoteTaskService';
import PostHearingLetterMergeData from '../../../models/PostHearingLetterMergeData';

@Component({

})
export default class PostHearingLetter extends Vue {
    @Prop() hearingDetails!: any;

    generatedPDF: any = null;
    generatedPDFFileLocation = '';
    emailError: Boolean = false;

    mergeFieldData: PostHearingLetterMergeData = {
        printLogo: true,
        createdBy: this.$store.state.user.userName,
        documentName: "PostHearingLetter",
        documentTitle: "Post Hearing Letter for Claim Number: " + this.hearingDetails.claimNumber,
        description: "Post Hearing Letter for Claim Number: " + this.hearingDetails.claimNumber,
        deliveryMethod: this.deliveryMethod,
        ccRecipients: 'copy these folks on emails',
        iwPresent: false,
        iwAttorneyPresent: false,
        iwAttorneyName: '',
        referredTo: '',
        iwAttorneyReferredTo: '',
        hearingOfficerDecision: '',
        bwcClaimNumber: this.hearingDetails.claimNumber,
        iwHearingInfo: '',
        pkHearing: 0,
        policyNumber: '',
        employerName: '',
        claimNumber: '',
        claimantName: '',
        hearingDateString: '',
        hearingDateTimeString: '',
        city: '',
        accountManagerEmail: '',
        accountManagerName: '',
        accountManagerPhone: '',
        hearingRep: '',
        hearingIssues: '',
        contactName: '',
        contactNameProperCase: '',
        contactAddress1: '',
        contactAddress2: '',
        contactCSZ: '',
        hearingOfficerType: {},
        hearingOfficerName: {},
        hearingDate: new Date,
        externalContacts: {},
        recipients: '',
        generalComments: ''
    }

    public hearingService = new HearingService();
    public noteTaskService = new NoteTaskService();

    get deliveryMethod() {
        return 'Email and create note'
    }
    get attorneyReliedOnRequired() {
        return this.mergeFieldData.iwAttorneyPresent ? 'required|max:800' : 'max:800';
    }
    get selectedExternalContacts() {
        var recip = '';

        if (this.mergeFieldData.externalContacts.selected)
            for (var i = 0; i <= this.mergeFieldData.externalContacts.selected.length - 1; i++) {
                recip += this.mergeFieldData.externalContacts.selected[i] + ';';
            }

        return recip;
    }

    createNoteSaveObj(): NoteTaskSave {
        let obj: NoteTaskSave = {
            pkNote: 0, fkParent: 0, fkParentLocation: 0, subject: '', fkCategory: 0, currentUserID: '', note: '',
            warningNote: 0, fkCompany: 0, fkDepartment: 0, hasAttachment: 0, hasWorkingOn: 0, privilege: 0, objectDataID: 0, fkHearing: 0,
            attachments: [], assignedColleagues: [], isTask: false, dueDate: '', escalationDays: 0
        };

        obj.currentUserID = this.$store.state.user.userName;
        obj.fkParent = this.hearingDetails.fkParent;
        obj.fkParentLocation = this.hearingDetails.fkParentLocation;
        obj.hasAttachment = 1;
        obj.attachments.push(this.generatedPDFFileLocation);
        obj.fkHearing = this.hearingDetails.pkHearing;

        obj.fkCompany = 1;
        obj.fkDepartment = 8;
        if (this.mergeFieldData.hearingOfficerType.description == "District Hearing Officer")
            obj.fkCategory = 1025;
        else if (this.mergeFieldData.hearingOfficerType.description == "Staff Hearing Officer")
            obj.fkCategory = 1024;
        else
            obj.fkCategory = 1030;
        obj.subject = "Hearing Rep";
        obj.privilege = 14;
        obj.note = this.mergeFieldData.hearingOfficerType + " - " + this.mergeFieldData.hearingOfficerName + "</br>";
        obj.note += "Recipients: " + this.mergeFieldData.recipients;

        return obj;
    }

    saveNote(): Promise<any> {
        let obj = this.createNoteSaveObj();

        return this.noteTaskService.AddOrUpdateNote(obj)
            .then((response) => {
                if (response) {
                    var msgs: any[] = [];
                    msgs.push('Note saved successfully!');

                    this.$store.dispatch('addApplicationMessages', { class: 'success', messages: msgs });
                }
            })
            .catch(error => {
                //add message with error information
            })
    }

    processEmail() {
        let subject = 'Hearing ' + this.hearingDetails.hearingDate + ', claim ' + this.hearingDetails.claimNumber + ", IW " + this.mergeFieldData.claimantName;
        let message = 'Attached, please find our report of attendance at your company\'s recent Ohio Workers\' Compensation hearing. Should you have any questions, please notify your claims examiner via the contact information at the bottom of the attached letter.';
        let req = { subject: subject, message: message, recipients: this.mergeFieldData.recipients, attachments: this.generatedPDFFileLocation, ccList: '', fromEmail: this.$store.getters.userEmail }

        this.noteTaskService.SendEmail(req)
            .then((response) => {
                if (response) {
                    this.$store.dispatch('addApplicationMessages', { class: 'success', messages: ["Email queued successfully!"] });
                }
                else {
                    this.$store.dispatch('addApplicationMessages', { class: 'error', messages: ["Something went wrong"] });
                }
                this.$store.dispatch("isLoading", false);
            })
            .catch(error => { })
    }

    uploadFileAndSaveNoteEmail() {
        //upload the pdf we created to the file share on network server,
        //then save the note with the attachmant location
        //then save email with the attachment location
        //let tempFile = new File([this.generatedPDF], "PostHearingLetter_" + this.hearingDetails.claimNumber + ".pdf");
        //let tempFile = new File([this.generatedPDF], "PostHearingLetter_" + this.hearingDetails.claimNumber + ".pdf");
        let fileRequest: Array<any> = [];

        fileRequest.push({ 'file': this.generatedPDF, 'fileName': "PostHearingLetter_" + this.hearingDetails.claimNumber + ".pdf" });

        this.noteTaskService.UploadFiles(fileRequest, this.$store.state.user.userName)
            .then((response) => {
                console.log('post hearing letter received response from uploading file.');
                if (response) {
                    this.generatedPDFFileLocation = response[0].filePath

                    this.saveNote();
                    this.processEmail();

                    //close the post hearing component in an effort to avoid the users accidentally sending the post hearing letter twice
                    this.$emit('closePostDialog');
                }
            })
    }

    send() {
        this.$validator.validate()
            .then((result) => {
                if (result) {
                    this.$store.dispatch("isLoading", true);

                    if (!this.generatedPDF)
                        this.createLetter()
                            .then((response) => {
                                this.uploadFileAndSaveNoteEmail();
                            })
                    else
                        this.uploadFileAndSaveNoteEmail();
                }
            });
    }

    //createAndSendLetter(): Promise<any> {
    //    this.$store.dispatch("isLoading", true);
    //    var tempHearingOfficerType = this.mergeFieldData.hearingOfficerType.description;
    //    var tempHearingOfficer = this.mergeFieldData.hearingOfficerName.description;

    //    this.mergeFieldData.hearingOfficerType = tempHearingOfficerType;
    //    this.mergeFieldData.hearingOfficerName = tempHearingOfficer;
    //    this.mergeFieldData.recipients = this.selectedExternalContacts;

    //    //todo: sc - new service method to call new api to create pdf and then create note/email

    //    return this.hearingService.CreatePostHearingLetter(this.mergeFieldData)
    //        .then((resp) => {
    //            this.$store.dispatch("isLoading", false);
    //            console.log('create post hearing letter routine finished.');
    //            this.generatedPDF = new Blob([resp], { type: resp.type });
    //            console.log('leaving post hearing letter routine.');
    //            return this.generatedPDF;
    //        });
    //}

    createLetter(): Promise<any> {
        var tempHearingOfficerType = this.mergeFieldData.hearingOfficerType.description;
        var tempHearingOfficer = this.mergeFieldData.hearingOfficerName.description;

        this.mergeFieldData.hearingOfficerType = tempHearingOfficerType;
        this.mergeFieldData.hearingOfficerName = tempHearingOfficer;
        this.mergeFieldData.recipients = this.selectedExternalContacts;
        return this.hearingService.CreatePostHearingLetter(this.mergeFieldData)
            .then((resp) => {
                console.log('create post hearing letter routine finished.');
                this.generatedPDF = new Blob([resp], { type: resp.type });
                console.log('leaving post hearing letter routine.');
                return this.generatedPDF;
            });
    }

    previewLetter() {
        this.$validator.validate()
            .then((result) => {
                if (result) {
                    this.generatedPDF = null;

                    return this.createLetter()
                        .then((response) => {
                            this.$store.dispatch("isLoading", false);

                            // It is necessary to create a new blob object with mime-type 
                            // explicitly set otherwise only Chrome works like it should
                            let newBlob = this.generatedPDF;

                            // IE doesn't allow using a blob object directly as link href 
                            // instead it is necessary to use msSaveOrOpenBlob
                            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                                window.navigator.msSaveOrOpenBlob(newBlob);
                                return;
                            }

                            // For other browsers: 
                            // Create a link pointing to the ObjectURL containing the blob.
                            let data = window.URL.createObjectURL(newBlob);
                            let link = document.createElement('a');
                            link.href = data;
                            link.target = "_blank";
                            //link.download = "testing.pdf";    //this will force it to download automatically
                            link.click();
                            setTimeout(() => {
                                // For Firefox it is necessary to delay revoking the ObjectURL
                                window.URL.revokeObjectURL(data);
                            }, 100);
                        });
                }
            });
    }

    addManualEntry(item: any) {
        let newEmail = item.currentTarget._value;

        if (newEmail) {
            let regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

            this.emailError = !regexp.test(newEmail);

            if (!this.emailError) {
                const index = this.mergeFieldData.externalContacts.selected.indexOf(newEmail);
                if (index == -1) {
                    this.mergeFieldData.externalContacts.data.push({ id: 0, eMail: newEmail, name: newEmail });
                    this.mergeFieldData.externalContacts.selected.push(newEmail);
                }
            }
        }
    }

    remove(item: any) {
        const index = this.mergeFieldData.externalContacts.selected.indexOf(item.eMail)
        if (index >= 0) this.mergeFieldData.externalContacts.selected.splice(index, 1)

        //id of zero indicates it was a manually entered email address, not part of the 
        //data returned from the api and we need to remove it from the original data source
        if (item.id == 0) {
            const dataIdx = this.mergeFieldData.externalContacts.data.indexOf(item);
            if (dataIdx >= 0)
                this.mergeFieldData.externalContacts.data.splice(dataIdx, 1);
        }
    }

    mounted() {
        let req = {
            'pkHearing': this.hearingDetails.pkHearing,
            'user': this.$store.state.user.userName,
            'employerID': this.hearingDetails.empl
        };
        this.hearingService.GetPostHearingLetterDataFields(req)
            .then((resp: PostHearingLetterMergeData) => {
                this.mergeFieldData = resp;
                Vue.set(this.mergeFieldData.externalContacts, 'selected', []);
                this.mergeFieldData.deliveryMethod = this.deliveryMethod;
                this.mergeFieldData.createdBy = this.$store.state.user.userName;
                this.mergeFieldData.printLogo = true;
            });
    }
}



// WEBPACK FOOTER //
// ./ClientApp/src/portalhome/docketing/letters/posthearingletter.ts